import { Component, OnDestroy, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {SpecialDayService} from "../../../../education/components/special-day/special-day.service";
import {GroupSessionTopics} from "../group-session-topics.model";
import {GroupSessionTopicsService} from "../group-session-topics.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-view-group-session-topics',
  templateUrl: './view-group-session-topics.component.html',
  styleUrls: ['./view-group-session-topics.component.scss']
})
export class ViewGroupSessionTopicsComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  groupSession!: GroupSessionTopics | null;
  isLoading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private groupSessionService: GroupSessionTopicsService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.groupSessionService.getDataById(id).pipe(takeUntil(this._destroyed$)).subscribe(data => {
        console.log(data);
        this.groupSession = data ?? null;
        this.isLoading = false;
      });
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  extractFileName(url?: string): string {
    if (!url) return '';
    const decoded = decodeURIComponent(url);
    const lastPart = decoded.split('/').pop() || "";
    return lastPart.split('?')[0];
  }

}
